<template>
  <div>
    <div class="nav-header flex-box"
         :style="{height: height + 'px',paddingLeft: paddingLeft + 'px',paddingRight: paddingRight + 'px',borderBottom: borderBottom ? borderBottom : '1px solid #e5e5e5'}">
         <!-- <div class="nav-header flex-box"> -->
      <h3 class="title">
        <slot name="line"><i class="line"></i></slot>
        <slot name="title"></slot>
      </h3>
      <div class="g-flex-right">
        <slot name="right"></slot>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {};
    },
    props: {
      "height": {
        type: Number,
        default: 50
      },
      "paddingRight": {
        type: Number,
        default: 10
      },
      "paddingLeft": {
        type: Number,
        default: 25
      },
      "borderBottom": {
        type: String
      }
    }
  };
</script>

<style scoped lang="scss">
  @import '../assets/css/mixin';

  .nav-header {
    box-sizing: border-box;
    display: flex;

    .title {
      font-size: 16px;
      font-weight: 700;
      height: 18px;
      position: relative;
      margin-left: 20px;

      .line {
        display: block;
        position: absolute;
        left: -20px;
        top: 1px;
        height: 19px;
        width: 4px;
        background: $main;
        vertical-align: middle;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/header.vue